// fr.gestionpial.pial.services.RepartitionBOServiceI generated by ic2 no-version-available at Thu Oct 01 15:16:26 UTC 2026
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IRPC, JSONSerializer, JSONRpcRequest, JSONRpcResponse, RpcRequestBuilder } from '@ic2/ic2-lib';
import { RepartitionPropositionDTO } from '../entities/RepartitionPropositionDTO';
import { PropositionAffectationDTO } from '../entities/PropositionAffectationDTO';

@Injectable({
  providedIn: 'root',
})
export class RepartitionBOService {
  private irpc = inject(IRPC);

  lancerReajustement = (idPial: number, idEcole: number, volumeSupplementaire: number, dateReference: Date): RpcRequestBuilder<RepartitionPropositionDTO> => {
    const req = new JSONRpcRequest();
    req.method = 'RepartitionBOService.lancerReajustement';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(idPial, 'java.lang.Integer', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(idEcole, 'java.lang.Integer', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(volumeSupplementaire, 'java.lang.Integer', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(dateReference, 'java.time.LocalDate', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, 'fr.gestionpial.pial.dto.RepartitionPropositionDTO');
  };

  lancerRepartitionAuto = (idPial: number, dateReference: Date): RpcRequestBuilder<RepartitionPropositionDTO> => {
    const req = new JSONRpcRequest();
    req.method = 'RepartitionBOService.lancerRepartitionAuto';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(idPial, 'java.lang.Integer', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(dateReference, 'java.time.LocalDate', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, 'fr.gestionpial.pial.dto.RepartitionPropositionDTO');
  };

  validerReajustement = (idPial: number, dateReference: Date, propositions: PropositionAffectationDTO[]): RpcRequestBuilder<void> => {
    const req = new JSONRpcRequest();
    req.method = 'RepartitionBOService.validerReajustement';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(idPial, 'java.lang.Integer', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(dateReference, 'java.time.LocalDate', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(propositions, 'java.util.List<fr.gestionpial.pial.dto.PropositionAffectationDTO>', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, null);
  };

  validerRepartition = (idPial: number, dateReference: Date, propositions: PropositionAffectationDTO[]): RpcRequestBuilder<void> => {
    const req = new JSONRpcRequest();
    req.method = 'RepartitionBOService.validerRepartition';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(idPial, 'java.lang.Integer', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(dateReference, 'java.time.LocalDate', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(propositions, 'java.util.List<fr.gestionpial.pial.dto.PropositionAffectationDTO>', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, null);
  };

}
